import { render } from "./ShopMenu.vue?vue&type=template&id=f1f0fea2"
import script from "./ShopMenu.vue?vue&type=script&lang=js"
export * from "./ShopMenu.vue?vue&type=script&lang=js"

import "./ShopMenu.vue?vue&type=style&index=0&id=f1f0fea2&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__